// Gerado por tools/assets (`pnpm --filter @eldrun/assets models`). Não edite à mão.
// Fonte: tools/assets/src/creatures/; relatório em docs/assets/model-build-report.json.

/**
 * Criaturas animadas (F50): por criatura, um arquivo (hash do conteúdo no nome) com o corpo de cada
 * variante e, se `glow`, a peça acesa; os triângulos e a altura parado (m). Os clipes: duração
 * (s) e laço; na locomoção, a velocidade (m/s) em que os pés não escorregam com o clipe a 1×; nos
 * golpes, o instante (s) do impacto, que o jogo põe no acerto do servidor.
 */
export const CREATURE_MODELS = {
  "corpo-seco": {
    url: "/modelos/criaturas/corpo-seco.7623a168.glb",
    glow: false,
    variants: {
      "lacaio": { tris: 1114, height: 1.743 },
      "ladino": { tris: 1119, height: 1.833 },
      "mago": { tris: 1120, height: 2.186 },
    },
    clips: {
      "parado": { duration: 2.1333, loop: true },
      "andando": { duration: 1.0667, loop: true, speed: 1.064 },
      "correndo": { duration: 0.8, loop: true, speed: 2.722 },
      "morte": { duration: 0.8, loop: false },
      "golpe:garra": { duration: 1.7917, loop: false, impact: 0.567 },
    },
  },
  "corpo-seco-anciao": {
    url: "/modelos/criaturas/corpo-seco-anciao.c9a9c540.glb",
    glow: false,
    variants: {
      "guerreiro": { tris: 1120, height: 2.664 },
    },
    clips: {
      "parado": { duration: 2.1333, loop: true },
      "andando": { duration: 1.0667, loop: true, speed: 1.365 },
      "correndo": { duration: 0.8, loop: true, speed: 3.841 },
      "morte": { duration: 0.8, loop: false },
      "golpe:raizes": { duration: 2.7083, loop: false, impact: 0.767 },
      "golpe:varrida": { duration: 1.6667, loop: false, impact: 0.667 },
    },
  },
  "cuca": {
    url: "/modelos/criaturas/cuca.8bc4dce4.glb",
    glow: false,
    variants: {
      "bruxa": { tris: 1000, height: 2.221 },
    },
    clips: {
      "parado": { duration: 2.1333, loop: true },
      "andando": { duration: 1.0667, loop: true, speed: 1.064 },
      "correndo": { duration: 0.8, loop: true, speed: 2.722 },
      "morte": { duration: 0.8, loop: false },
      "golpe:caldeirao": { duration: 1.3667, loop: false, impact: 0.638 },
      "golpe:colherada": { duration: 0.4583, loop: false, impact: 0.229 },
    },
  },
  "cuca-rainha": {
    url: "/modelos/criaturas/cuca-rainha.a2ec726c.glb",
    glow: false,
    variants: {
      "rainha": { tris: 1180, height: 2.887 },
    },
    clips: {
      "parado": { duration: 2.1333, loop: true },
      "andando": { duration: 1.0667, loop: true, speed: 1.3 },
      "correndo": { duration: 0.8, loop: true, speed: 3.545 },
      "morte": { duration: 0.8, loop: false },
      "golpe:caldeiroes": { duration: 1.875, loop: false, impact: 0.75 },
      "golpe:caldeiroes-pocas": { duration: 1.875, loop: false, impact: 0.75 },
      "golpe:cantiga": { duration: 1.6667, loop: false, impact: 0.556 },
    },
  },
  "mula-sem-cabeca": {
    url: "/modelos/criaturas/mula-sem-cabeca.c91011fa.glb",
    glow: true,
    variants: {
      "cavalo": { tris: 1000, height: 1.898 },
    },
    clips: {
      "parado": { duration: 2.6667, loop: true },
      "andando": { duration: 0.9667, loop: true, speed: 1.374 },
      "correndo": { duration: 0.4333, loop: true, speed: 4.645 },
      "morte": { duration: 1.4, loop: false },
      "golpe:carga": { duration: 1, loop: false, impact: 0.55 },
    },
  },
  "matinta-pereira": {
    url: "/modelos/criaturas/matinta-pereira.532542d4.glb",
    glow: false,
    variants: {
      "ave": { tris: 700, height: 0.825 },
    },
    clips: {
      "parado": { duration: 0.625, loop: true },
      "andando": { duration: 0.625, loop: true },
      "correndo": { duration: 0.625, loop: true },
      "morte": { duration: 0.5, loop: false },
      "golpe:mergulho": { duration: 0.625, loop: false, impact: 0.625 },
    },
  },
  "lobisomem": {
    url: "/modelos/criaturas/lobisomem.17c17ab3.glb",
    glow: false,
    variants: {
      "lobo": { tris: 999, height: 1.376 },
    },
    clips: {
      "parado": { duration: 1.3333, loop: true },
      "andando": { duration: 1, loop: true, speed: 0.95 },
      "correndo": { duration: 0.4667, loop: true, speed: 7.228 },
      "morte": { duration: 1.1667, loop: false },
      "golpe:mordida": { duration: 0.8667, loop: false, impact: 0.462 },
      "golpe:salto": { duration: 2.2, loop: false, impact: 0.5 },
    },
  },
  "cabra-cabriola": {
    url: "/modelos/criaturas/cabra-cabriola.fd3b2075.glb",
    glow: false,
    variants: {
      "quimera": { tris: 1300, height: 2.228 },
    },
    clips: {
      "parado": { duration: 2.6667, loop: true },
      "andando": { duration: 0.9667, loop: true, speed: 1.455 },
      "correndo": { duration: 0.4333, loop: true, speed: 4.889 },
      "morte": { duration: 1.4, loop: false },
      "golpe:investidas": { duration: 1, loop: false, impact: 0.55 },
      "golpe:investidas-fogo": { duration: 1, loop: false, impact: 0.55 },
      "golpe:fogo": { duration: 2.9333, loop: false, impact: 0.831 },
      "golpe:coice": { duration: 1.3, loop: false, impact: 0.758 },
    },
  },
  "capivara": {
    url: "/modelos/criaturas/capivara.98998283.glb",
    glow: false,
    variants: {
      "cervo": { tris: 998, height: 1.342 },
    },
    clips: {
      "parado": { duration: 2.6667, loop: true },
      "andando": { duration: 0.9667, loop: true, speed: 0.723 },
      "correndo": { duration: 0.4333, loop: true, speed: 2.58 },
      "morte": { duration: 1.4, loop: false },
    },
  },
  "capelobo": {
    url: "/modelos/criaturas/capelobo.7afc1633.glb",
    glow: true,
    variants: {
      "troll": { tris: 196, height: 2.122 },
    },
    clips: {
      "parado": { duration: 1.3333, loop: true },
      "andando": { duration: 1.4167, loop: true, speed: 0.605 },
      "correndo": { duration: 1.1667, loop: true, speed: 3.91 },
      "morte": { duration: 1.875, loop: false },
      "golpe:pancada": { duration: 2.7083, loop: false, impact: 0.767 },
      "golpe:agarrao": { duration: 1.7917, loop: false, impact: 0.567 },
    },
  },
  "mapinguari": {
    url: "/modelos/criaturas/mapinguari.5e193511.glb",
    glow: true,
    variants: {
      "ciclope": { tris: 292, height: 3.548 },
    },
    clips: {
      "parado": { duration: 3.125, loop: true },
      "andando": { duration: 1.4167, loop: true, speed: 0.657 },
      "correndo": { duration: 1.1667, loop: true, speed: 5.007 },
      "morte": { duration: 2.2083, loop: false },
      "golpe:pancada": { duration: 1.6667, loop: false, impact: 0.667 },
      "golpe:pancada-investida": { duration: 1.6667, loop: false, impact: 0.667 },
      "golpe:investida": { duration: 1.25, loop: false, impact: 0.219 },
      "golpe:tronco": { duration: 1.875, loop: false, impact: 0.75 },
      "golpe:bafo": { duration: 3.7083, loop: false, impact: 1.16 },
    },
  },
  "guardiao-verde": {
    url: "/modelos/criaturas/guardiao-verde.7f8b3d60.glb",
    glow: true,
    variants: {
      "guardiao": { tris: 220, height: 2.713 },
    },
    clips: {
      "parado": { duration: 1.7083, loop: true },
      "andando": { duration: 1.6667, loop: true, speed: 0.693 },
      "correndo": { duration: 1.1667, loop: true, speed: 4.173 },
      "morte": { duration: 2.1667, loop: false },
      "golpe:golpe-1": { duration: 1.0833, loop: false, impact: 0.181 },
      "golpe:golpe-2": { duration: 1.25, loop: false, impact: 0.219 },
      "golpe:salto": { duration: 1.625, loop: false, impact: 1.205 },
      "golpe:area": { duration: 1.3333, loop: false, impact: 0.356 },
    },
  },
  "guardiao-azul": {
    url: "/modelos/criaturas/guardiao-azul.b480795c.glb",
    glow: true,
    variants: {
      "guardiao": { tris: 220, height: 2.713 },
    },
    clips: {
      "parado": { duration: 1.7083, loop: true },
      "andando": { duration: 1.6667, loop: true, speed: 0.693 },
      "correndo": { duration: 1.1667, loop: true, speed: 4.173 },
      "morte": { duration: 2.1667, loop: false },
      "golpe:golpe-1": { duration: 1.0833, loop: false, impact: 0.181 },
      "golpe:golpe-2": { duration: 1.25, loop: false, impact: 0.219 },
      "golpe:salto": { duration: 1.625, loop: false, impact: 1.205 },
      "golpe:area": { duration: 1.3333, loop: false, impact: 0.356 },
      "golpe:onda": { duration: 2.7083, loop: false, impact: 0.767 },
    },
  },
  "guardiao-vermelho": {
    url: "/modelos/criaturas/guardiao-vermelho.9a60a90a.glb",
    glow: true,
    variants: {
      "guardiao": { tris: 220, height: 2.713 },
    },
    clips: {
      "parado": { duration: 1.7083, loop: true },
      "andando": { duration: 1.6667, loop: true, speed: 0.693 },
      "correndo": { duration: 1.1667, loop: true, speed: 4.173 },
      "morte": { duration: 2.1667, loop: false },
      "golpe:golpe-1": { duration: 1.0833, loop: false, impact: 0.181 },
      "golpe:golpe-2": { duration: 1.25, loop: false, impact: 0.219 },
      "golpe:salto": { duration: 1.625, loop: false, impact: 1.205 },
      "golpe:area": { duration: 1.3333, loop: false, impact: 0.356 },
    },
  },
  "guardiao-amarelo": {
    url: "/modelos/criaturas/guardiao-amarelo.9d452f50.glb",
    glow: true,
    variants: {
      "guardiao": { tris: 220, height: 2.713 },
    },
    clips: {
      "parado": { duration: 1.7083, loop: true },
      "andando": { duration: 1.6667, loop: true, speed: 0.693 },
      "correndo": { duration: 1.1667, loop: true, speed: 4.173 },
      "morte": { duration: 2.1667, loop: false },
      "golpe:golpe-1": { duration: 1.0833, loop: false, impact: 0.181 },
      "golpe:golpe-2": { duration: 1.25, loop: false, impact: 0.219 },
      "golpe:salto": { duration: 1.625, loop: false, impact: 1.205 },
      "golpe:area": { duration: 1.3333, loop: false, impact: 0.356 },
      "golpe:raios": { duration: 1.3333, loop: false, impact: 0.356 },
    },
  },
  "guardiao-rosa": {
    url: "/modelos/criaturas/guardiao-rosa.7ef19434.glb",
    glow: true,
    variants: {
      "guardiao": { tris: 220, height: 2.713 },
    },
    clips: {
      "parado": { duration: 1.7083, loop: true },
      "andando": { duration: 1.6667, loop: true, speed: 0.693 },
      "correndo": { duration: 1.1667, loop: true, speed: 4.173 },
      "morte": { duration: 2.1667, loop: false },
      "golpe:golpe-1": { duration: 1.0833, loop: false, impact: 0.181 },
      "golpe:golpe-2": { duration: 1.25, loop: false, impact: 0.219 },
      "golpe:salto": { duration: 1.625, loop: false, impact: 1.205 },
      "golpe:area": { duration: 1.3333, loop: false, impact: 0.356 },
    },
  },
  "lobisomem-alfa": {
    url: "/modelos/criaturas/lobisomem-alfa.0e802ac6.glb",
    glow: false,
    variants: {
      "lobo": { tris: 1000, height: 2.02 },
    },
    clips: {
      "parado": { duration: 1.3333, loop: true },
      "andando": { duration: 1, loop: true, speed: 1.5 },
      "correndo": { duration: 0.4667, loop: true, speed: 12.806 },
      "morte": { duration: 1.1667, loop: false },
      "golpe:mordida": { duration: 0.8667, loop: false, impact: 0.462 },
      "golpe:salto": { duration: 2.2, loop: false, impact: 0.5 },
    },
  },
  "corpo-seco-colosso": {
    url: "/modelos/criaturas/corpo-seco-colosso.c891ad81.glb",
    glow: false,
    variants: {
      "colosso": { tris: 1099, height: 3.46 },
    },
    clips: {
      "parado": { duration: 2.1333, loop: true },
      "andando": { duration: 1.0667, loop: true, speed: 1.605 },
      "correndo": { duration: 0.8, loop: true, speed: 4.939 },
      "morte": { duration: 0.8, loop: false },
      "golpe:garra": { duration: 1.7917, loop: false, impact: 0.567 },
      "golpe:pancada": { duration: 2.7083, loop: false, impact: 0.767 },
    },
  },
  "capelobo-ancestral": {
    url: "/modelos/criaturas/capelobo-ancestral.8092be18.glb",
    glow: true,
    variants: {
      "troll": { tris: 400, height: 2.865 },
    },
    clips: {
      "parado": { duration: 1.3333, loop: true },
      "andando": { duration: 1.4167, loop: true, speed: 0.775 },
      "correndo": { duration: 1.1667, loop: true, speed: 5.314 },
      "morte": { duration: 1.875, loop: false },
      "golpe:pancada": { duration: 2.7083, loop: false, impact: 0.767 },
      "golpe:agarrao": { duration: 1.7917, loop: false, impact: 0.567 },
    },
  },
  "boitata": {
    url: "/modelos/criaturas/boitata.f406f453.glb",
    glow: true,
    variants: {
      "dragao": { tris: 1295, height: 2.546 },
    },
    clips: {
      "parado": { duration: 2, loop: true },
      "andando": { duration: 2, loop: true, speed: 7 },
      "correndo": { duration: 0.75, loop: true, speed: 14 },
      "morte": { duration: 1.4, loop: false },
      "golpe:cuspe": { duration: 1.3, loop: false, impact: 0.8 },
      "golpe:bote": { duration: 1.3, loop: false, impact: 0.62 },
      "golpe:chicote": { duration: 1.4, loop: false, impact: 0.72 },
      "golpe:sopro": { duration: 3.4, loop: false, impact: 1.1 },
      "golpe:rastro": { duration: 1.5, loop: false, impact: 0.75 },
      "golpe:chuva": { duration: 3.8, loop: false, impact: 1 },
    },
  },
} as const;
